const config = {
  criteriaTitle: ["required", "trim", "string"],
};

export default config;
